import { Component, OnInit, Input } from '@angular/core';
import { HomeService } from 'src/app/core/http/web/home.service';
import { environment as params } from 'src/environments/environment';

declare var $: any;

@Component({
  selector: 'app-promo-products',
  templateUrl: './promo-products.component.html',
  styleUrls: ['./promo-products.component.scss']
})
export class PromoProductsComponent implements OnInit {
  destinoSlickOptions = {
    responsive: [
      {
        breakpoint: 768,
        settings: {
          // slidesToShow: 1.7
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };
  @Input('load_serv') public load_serv: boolean = true;
  @Input('data') public promoProduct: any = null;
  prodComp: any = null;
  urlBaseS3: any = (<any>params).api.s3;
  public errors: any;
  public loadings: any = true;
  public maxItems: any;
  public descOpen: boolean;
  public productsShow: any;
  @Input('route') public route: string;
  constructor(private _homeService: HomeService) {
    this.maxItems = 5;
  }

  ngOnInit() {
    if (this.load_serv) {
      this.getPromoProduct();
    }
  }

  getPromoProduct() {
    this._homeService.getPromoProduct(this.route).subscribe(
      data => {
        console.log('Promo producto', data);
        this.promoProduct = data.promoproducto;
        if (
          !(
            data.promoproducto &&
            data.promoproducto.content_post &&
            data.promoproducto.content_post.length > 0
          )
        ) {
          console.warn('Sin promociones productos para mostrar');
          this.loadings = false;
        }
      },
      err => {
        console.error('Error al obtener promociones productos', err);
        this.errors = err;
      }
    );
  }
  getPrice(value, price = true) {
    if (price) {
      return value.split('$')[1];
    } else {
      return value.split('$')[0];
    }
  }
  locationHref(url) {
    window.location.href = url;
  }
  descubreMas() {
    if (this.descOpen || this.promoProduct.content_post.length <= this.maxItems) {
      this.locationHref(this.promoProduct.link);
    } else {
      this.descOpen = true;
      this.maxItems = 8;
    }
  }

  reload() {
    this.loadings = true;
    this.getPromoProduct();
  }
}
